export interface NavigationItem {
  label: string
  loginRequired: boolean
  link: string
  isNewTab: boolean
  modalId?: string
  modalTab?: string
  icon?: string
  iconLabel?: string
}
export interface PageInfo {
  name: string
  path: string
  instructionLink?: string
}
export interface FooterNavigationItem {
  title: string
  icon: string
  iconType?: 'webp' | 'svg'
  link: string
  modalIdOpen?: string
  loginRequired: boolean
  isNewTab: boolean
  isActive?: boolean
  routeActive?: string | string[]
}
export interface NavigationFooterSubItem {
  subTitle: string
  link: string
}

export interface NavigationFooterItem {
  title: string
  subMenus: NavigationFooterSubItem[]
  subTitle?: string
  label?: string
}

export interface PartnerItem {
  title: string
  logo: string
  link?: string
}

export interface ContactItem {
  label: string
  title?: string
  link?: string
  icon?: string
  img?: string
  newTab?: boolean
  type?: string
  isNewTab?: boolean
  detail?: string
  detailScheme?: string
}

export interface HttpResponse {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
  status?: string
  message?: string
  statusCode?: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export interface BannerItem {
  imgSrc: string
  link?: string
  loginRequired?: boolean
  type?: string
  gameId?: string
  provider?: string
}
export interface PromotionBannerItem {
  isNavigateEventPage?: boolean
  title: string
  packageId: number
  packageName?: string
  subTitle: string
  link: string
  slug: string
  imgSrc: string
  thumbnailUrl: string
  thumbnailUrlMb: string
  accountPageUrl: string
  badgeTitle?: string
  footer: {
    text: string
    highlight?: string
    button?: { link: string; text: string }
  }
}

export interface MatchData {
  isDisable?: boolean
  teams: Array<{
    name: string
    flag_thumbnail: string
  }>
  league_name: string
  league_name_text: string
  league_image: string
  league_id: string | number
  match_id: string | number
  text_time: string
  hTeam?: {
    rate: string
    odds: string
  }
  aTeam?: {
    rate: string
    odds: string
  }
  overFT?: {
    hTeam?: {
      rate: string
      odds: string
    }
    aTeam?: {
      rate: string
      odds: string
    }
  }
  athena_league_id: string | number
  athena_match_id: string | number
  athena_ahFT?: {
    hTeam?: {
      rate: string
      odds: string
    }
    aTeam?: {
      rate: string
      odds: string
    }
  }
  athena_overFT?: {
    hTeam?: {
      rate: string
      odds: string
    }
    aTeam?: {
      rate: string
      odds: string
    }
    favorite: boolean
  }
}
export interface TeamData {
  flag_thumbnail: string
  name: string
}

export interface PlaySportItem {
  link?: string
  loginRequired?: boolean
  newTab?: boolean
  isMaintain?: boolean
  isComingSoon?: boolean
}

export interface SportGameItem {
  id: number
  link: string
  alias: string
  loginRequired: boolean
  newTab: boolean
  isMaintain: boolean
  label: string
  imageUrl: string
  imageUrlMobile: string
  imgLabel: string
  imgLabelMb?: string
  labelMaintance: string
  isAgency?: boolean
  isHideOnDesktop?: boolean
  isComingSoon?: boolean
  labelComingSoon?: string
  hoverImageUrl?: string
}
export interface IntroductionItem {
  id: number
  link: string
  name: string
  thumbnail: string
  description: string
}
export interface RoadMapItem {
  id: number
  name: string
  icon: string
  iconWidth: string
}

export interface CategorySchedules {
  thumb: string
  name: string
  slug: string
}

interface OddsTeams {
  hTeam: {
    odds: string
    rate: string
  }
  aTeam: {
    odds: string
    rate: string
  }
}
export interface MatchItem {
  live?: boolean
  score?: string
  text_time: string
  matchId: string
  ahHT: OddsTeams
  overHT: OddsTeams
  winHT: OddsTeams
  ahFT: OddsTeams
  overFT: OddsTeams
  winFT: OddsTeams
  timePlaying: string
  teams: Array<{
    name: string
    flag_thumbnail: string
  }>
}
export interface FootballSchedule {
  leagueName: string
  leagueId?: number
  matches: MatchItem[]
  apiName?: string
  rank?: number
  logo?: string
  thumb?: string
  slug?: string
  name?: string
}
export enum BehaviorScrollToTop {
  SMOOTH = 'smooth',
  INSTANT = 'instant',
  AUTO = 'auto'
}
